export const getChimeraToken = (): string => {
  const localStorageProfile = JSON.parse(localStorage.getItem('d-profile') as string);
  return localStorageProfile.object.d;
};

export const getDexToken = (): string | null => {
  const token = localStorage.getItem('token');
  return token;
};
